module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail7-8213fbec89b2f16cd1963df392fdfd45.jpg";